import { completionEvent } from '../lib/completion-analytics';
import { useState } from 'react';
import type { SeatCandidate } from '@anjabom/core';
import { seatSharePath } from '../lib/seat-share';

export function ShareSeatButton({ candidate }: { candidate: SeatCandidate }) {
  const [message, setMessage] = useState('');
  const [manualUrl, setManualUrl] = useState('');

  const share = async () => {
    const url = new URL(seatSharePath(candidate), 'https://anjabom.com').toString();
    const title = `${candidate.venueName} ${candidate.sectionCode} ${candidate.rowLabel}열 ${candidate.seatNumber}번`;
    try {
      if (navigator.share) {
        await navigator.share({ title: `${title} · 앉아봄`, text: '회차 배치와 같은 자리·근처 기록을 함께 확인해 보세요.', url });
        completionEvent('share_completed',{method:'link'});setMessage('좌석 확인 링크를 공유했어요.');
        return;
      }
      if (!navigator.clipboard?.writeText) throw new Error('clipboard_unavailable');
      await navigator.clipboard.writeText(url);
      completionEvent('share_completed',{method:'link'});setMessage('좌석 확인 링크를 복사했어요.');
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') return;
      setManualUrl(url);
      setMessage('자동으로 복사하지 못했어요. 아래 좌석 링크를 길게 눌러 복사해 주세요.');
    }
  };

  return (
    <>
      <button className="button" type="button" onClick={() => void share()}>이 좌석 공유하기</button>
      {message ? <span className="micro" role="status">{message}</span> : null}
      {manualUrl ? <label className="field"><span className="field-label">직접 복사할 좌석 링크</span><textarea className="textarea" readOnly value={manualUrl} onFocus={(event) => event.currentTarget.select()} /></label> : null}
    </>
  );
}
